export const normalizeEmail = (value) => String(value ?? "").trim().toLowerCase();

export const normalizeEmailForComparison = (value) => {
  const email = normalizeEmail(value);
  const atIndex = email.indexOf("@");

  if (atIndex <= 0) {
    return email;
  }

  const localPart = email.slice(0, atIndex);
  const domain = email.slice(atIndex + 1);
  const plusIndex = localPart.indexOf("+");
  const comparableLocalPart = plusIndex >= 0 ? localPart.slice(0, plusIndex) : localPart;

  return comparableLocalPart && domain ? `${comparableLocalPart}@${domain}` : email;
};

export const isEmailLike = (value) => {
  const email = normalizeEmail(value);
  return email.includes("@") && !email.includes(" ");
};
